<template>
  <div>
    <button
      class="explore-btn"
      @click="showModal = true"
    >
      <span class="explore-btn__img">
        <img
          :src="thumbnailImage"
          alt="">
      </span>
      <span class="explore-btn__text">
        <span class="explore-btn__prompt">{{ gettext('Explore:') }}</span>
        {{ modalTitle }}
      </span>
    </button>

    <modal
      :show="showModal"
      :container-max-width="'70rem'"
      @close="close">
      <div class="modal__header">
        <h3 class="u-mb-sm">{{ modalTitle }}</h3>
      </div>
      <div class="modal__body">
        <img
          :src="diagramImage"
          alt=""
          loading="lazy"
          class="u-mb-lg">
      </div>
      <div class="modal__response u-fontsize-sm u-text-right">
        <button
          type="button"
          class="btn btn--primary"
          role="button"
          @click.prevent="close">{{ gettext("Close") }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from './Modal'

export default {
  name: 'ArachnidDiagramModal',
  components: {
    Modal,
  },

  props: {
    diagramImage: {
      type: String,
      required: true,
    },
    thumbnailImage: {
      type: String,
      required: true,
    },
    modalTitle: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showModal: false
    }
  },

  methods: {
    close() {
      this.showModal = false
    }
  },
}
</script>
